function updateCartProgress(wrapper, total) {
    if (!wrapper) return;
    const minOrder = parseFloat(wrapper.dataset.minOrder) || 0;
    const freeShipping = parseFloat(wrapper.dataset.freeShipping) || 0;

    if (total <= 0) {
        wrapper.innerHTML = '';
        return;
    }

    let html = '';

    if (minOrder > 0 && total < minOrder) {
        html += '<div class="alert alert-warning">' +
            'Минимальная сумма заказа — ' + minOrder + ' ₽. ' +
            'Добавьте товаров ещё на ' + (minOrder - total) + ' ₽.' +
            '</div>';
    }

    if (freeShipping > 0) {
        const remaining = Math.max(0, freeShipping - total);
        const progressPercent = Math.min(100, Math.round(total / freeShipping * 100));
        const progressText = remaining > 0
            ? 'До бесплатной доставки осталось ' + remaining + ' ₽'
            : 'Бесплатная доставка!';

        html += '<div class="cart-progress mb-4">' +
            '<p class="mb-1">' + progressText + '</p>' +
            '<div class="progress" style="height: 20px;">' +
            '<div class="progress-bar bg-success" role="progressbar" style="width: ' + progressPercent + '%" ' +
            'aria-valuenow="' + progressPercent + '" aria-valuemin="0" aria-valuemax="100">' + progressPercent + '%</div>' +
            '</div>' +
            '</div>';
    }

    wrapper.innerHTML = html;
}

function updateCartTotal(wrapper, totalFormatted, currency, totalValue, minOrder, checkoutUrl) {
    if (!wrapper) return;

    if (totalValue <= 0) {
        wrapper.innerHTML = '';
        return;
    }

    let buttonHtml;
    if (totalValue >= minOrder) {
        buttonHtml = '<a href="' + checkoutUrl + '" class="btn btn-success">Оформить заказ</a>';
    } else {
        buttonHtml = '<button type="button" class="btn btn-success" disabled ' +
            'data-toggle="tooltip" title="Минимальный заказ ' + minOrder + ' ₽">' +
            'Оформить заказ' +
            '</button>';
    }

    wrapper.innerHTML = '<div class="basket-total-price">' +
        '<span><span id="cart__total-value">' + totalFormatted + '</span> ' + currency + '</span>' +
        buttonHtml +
        '</div>';

    $(wrapper).find('[data-toggle="tooltip"]').tooltip();
}

function getCartDataFromResponse(response) {
    if (!response || !response.data) {
        return null;
    }
    const data = response.data;
    const positionTotalPrice = data.position_total_price || {};
    const totalPrice = data.total_price || {};
    return {
        totalValue: parseFloat(positionTotalPrice.price_value || 0),
        totalFormatted: positionTotalPrice.price || totalPrice.price || '0',
        currency: data.currency || '₽'
    };
}

function refreshCartState(response) {
    const cartData = getCartDataFromResponse(response);
    if (!cartData) return;

    const progressWrapper = document.querySelector('.cart-progress-wrapper');
    const totalWrapper = document.querySelector('.basket-total');
    const minOrder = parseFloat(progressWrapper.dataset.minOrder) || 0;
    const checkoutUrl = progressWrapper.dataset.checkoutUrl || '/shop/checkout';

    updateCartProgress(progressWrapper, cartData.totalValue);
    updateCartTotal(totalWrapper, cartData.totalFormatted, cartData.currency, cartData.totalValue, minOrder, checkoutUrl);
}

document.querySelectorAll('.cart__delete-btn').forEach(button => {
    button.addEventListener('click', function (e) {
        oc.progressBar.show();
        const btnDelete = e.currentTarget;
        const cart = document.querySelector('.basket-block');
        const cartItemsNumber = cart.children.length;

        oc.attachLoader.show(btnDelete);

        oc.request(e.currentTarget, 'Cart::onRemove', {
            'data': {'cart': [btnDelete.getAttribute('data-id')]},
            success: function (response) {
                if (!!response && response.status && !!response.data) {
                    refreshCartState(response);
                    updateCartLinkHeader(btnDelete);

                    if (cartItemsNumber > 2) {
                        oc.attachLoader.hide(btnDelete);
                        btnDelete.parentElement.parentElement.remove();
                    } else if (cartItemsNumber === 2) {
                        cart.remove();
                        document.querySelector('.basket-total').remove();
                        document.querySelector('.cart__empty').classList.remove('hidden');
                    }

                    oc.progressBar.hide();
                }
            }
        });
    });
});

$('.basket-num-minus').on('click', function (e) {
    const btnMinus = $(e.currentTarget),
        numInput = btnMinus.siblings('.basket-num-input');

    let num = +numInput.val() - 1;
    numInput.val(num);
    numInput.trigger('change')
});

$('.basket-num-plus').on('click', function (e) {
    const btnPlus = $(e.currentTarget),
        numInput = btnPlus.siblings('.basket-num-input');

    let num = +numInput.val() + 1;
    numInput.val(num);
    numInput.trigger('change')
});

$('.quantity').on('change', function (e) {

    const quantity = $(e.currentTarget);
    let num = +quantity.val(),
        max = parseInt(quantity.attr('max'));
    if (num <= 1) {
        num = 1;
    }
    if (num >= max) {
        num = max;
    }
    quantity.val(num);


    const $quantityItem = $(e.currentTarget),
        cartItem = $quantityItem.parents('.basket-item'),
        dataPositionId = cartItem.attr('data-position-id'),
        data = {
            'cart': [
                {
                    'offer_id': cartItem.attr('data-offer-id'),
                    'quantity': $quantityItem.val()
                }
            ],
            'shipping_type_id': 1
        };

    oc.request(this, 'Cart::onUpdate', {
        data: data,
        success: function (response) {
            if (!!response && response.status && !!response.data) {
                const cartData = response.data,
                    priceData = cartData.position[dataPositionId];

                if (priceData) {
                    cartItem.find('.cart__position-price-value').html(priceData.price);
                }

                refreshCartState(response);
                updateCartLinkHeader(e.currentTarget);
            }
        }
    });
});
